// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"230":"89eb27ff","328":"4d28e180","399":"a92810fb","491":"fc22a7eb","675":"f4743b17","693":"3e9a8d4c","754":"3ac02a2f","845":"2d945789","861":"c97e490d"}[chunkId] + ".chunk.js";
};